<h2 style="cursor:pointer; display:block;" class="flex-aligned-div" (click)="openLogsHistory()">
  Logs History
  <mat-icon data-html="true" style="color:white">info</mat-icon>
</h2>
<div class="example-container">
  <table mat-table
    [dataSource]="dataSource"
    multiTemplateDataRows
    matSort
    class="mat-elevation-z8 mat-table-custom" id="remoteresetlist">
    @for (item of columnsToDisplay; track item) {
      <ng-container matColumnDef="{{item}}">
        <th mat-header-cell *matHeaderCellDef>
          {{item === 'actions' ? '' : item}}
        </th>
        @if (item==='actions') {
          <td mat-cell *matCellDef="let element">
            @if (defaults.isControllerOwner) {
              @if (getInput(element,'Enabled') === false) {
                <button mat-icon-button (click)="changeElement(element, 'Enabled', true)" matTooltip="Allow Reset Command">
                  <mat-icon class="mat-icon-grey">toggle_off</mat-icon>
                </button>
              }
              @if (getInput(element,'Enabled') === true) {
                <button mat-icon-button (click)="changeElement(element, 'Enabled', false)" matTooltip="Disallow Reset Command">
                  <mat-icon class="mat-icon-green">toggle_on</mat-icon>
                </button>
              }
            }
            @if (!defaults.isControllerOwner) {
              @if (getInput(element,'Enabled') === true) {
                <p class="mat-icon-green">Enabled</p>
              }
              @if (getInput(element,'Enabled') === false) {
                <p class="mat-icon-grey">Disabled</p>
              }
            }
          </td>
        }
        @if (item!=='actions') {
          <ng-container *matCellDef="let element">
            @switch (getDataType(item)) {
              @case ('string') {
                <td mat-cell>
                  <p [innerHTML]="getInput(element,item)"></p>
                </td>
              }
              @case ('date') {
                <td mat-cell class="datepicker">
                  <p [innerHTML]="getInput(element,item) | date:'yyyy-MM-dd HH:mm'"></p>
                </td>
              }
            }
          </ng-container>
        }
      </ng-container>
    }

    <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;" class="item">
    </table>
  </div>
